import { useTheme } from "@mui/material/styles";

const SafetyMenuIcon = () => {
  const theme = useTheme();

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_28738_4366)">
        <path
          d="M25.0414 20.1382H24.5929V18.498C24.5929 14.9691 22.4022 11.7685 19.1259 10.4847V10.09C19.1259 9.46916 18.6207 8.96402 17.9999 8.96402H13.9776C13.3568 8.96402 12.8517 9.46916 12.8517 10.09V10.4847C9.57516 11.7685 7.38468 14.9693 7.38468 18.4983V20.1384H6.93596C6.48043 20.1382 6.10986 20.5089 6.10986 20.9645V22.1873C6.10986 22.6428 6.48043 23.0134 6.93596 23.0134H25.0414C25.4969 23.0134 25.8677 22.6428 25.8677 22.1873V20.9645C25.8677 20.5089 25.4971 20.1382 25.0414 20.1382ZM7.82374 18.4983C7.82374 15.2073 9.83136 12.217 12.8517 10.9585V13.9094C12.8517 14.0306 12.95 14.1289 13.0712 14.1289C13.1924 14.1289 13.2907 14.0306 13.2907 13.9094V10.6362V10.09C13.2907 9.7113 13.599 9.40308 13.9776 9.40308H15.7692V16.0621C15.7692 16.1833 15.8676 16.2817 15.9888 16.2817C16.1099 16.2817 16.2083 16.1833 16.2083 16.0621V9.40308H17.9999C18.3788 9.40308 18.6868 9.7113 18.6868 10.09V10.636V13.9092C18.6868 14.0304 18.7849 14.1287 18.9063 14.1287C19.0277 14.1287 19.1259 14.0304 19.1259 13.9092V10.9582C22.1462 12.2168 24.1538 15.2071 24.1538 18.498V20.1382H7.82374V18.4983ZM25.4286 22.1873C25.4286 22.4007 25.255 22.5743 25.0414 22.5743H6.93596C6.72257 22.5743 6.54893 22.4007 6.54893 22.1873V20.9645C6.54893 20.7509 6.72257 20.5772 6.93596 20.5772H7.60399H24.3733H25.0414C25.255 20.5772 25.4286 20.7509 25.4286 20.9645V22.1873Z"
          fill={theme.palette.text.primary}
          stroke={theme.palette.text.primary}
        />
      </g>
      <defs>
        <clipPath id="clip0_28738_4366">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SafetyMenuIcon;
